export const ERRORS_STATE_KEY = 'errors';

export interface ErrorsState {
  hasSessionEnded: boolean
}

export const initialState: ErrorsState = {
  hasSessionEnded: false,
};
